import { truncateDecimals } from '@shared/helpers/formatters';

function formatNumberForDisplay(
  number: number,
  { minValue, maxDecimals }: { minValue: number; maxDecimals: number },
) {
  // If the number is less than MIN (e.g. 0.000001), display as '<0.000001'
  if (number < minValue) {
    return `<${minValue}`;
  } else {
    // Convert number to string with high precision
    const highPrecisionString = number.toFixed(20);
    // Truncate to needed decimal places and return
    return truncateDecimals(highPrecisionString, maxDecimals);
  }
}

export default formatNumberForDisplay;
